var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "64px",
    height: "64px",
    viewBox: "0 0 128 128",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.5.05v18.52a45.2 45.2 0 0 0-15.52 3.62l-9.3-16.1A63.67 63.67 0 0 1 61.5.05z",
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5.05v18.52a45.2 45.2 0 0 0-15.52 3.62l-9.3-16.1A63.67 63.67 0 0 1 61.5.05z",
    fill: "#f8f8f8",
    fillOpacity: 0.03,
    transform: "rotate(30 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5.05v18.52a45.2 45.2 0 0 0-15.52 3.62l-9.3-16.1A63.67 63.67 0 0 1 61.5.05z",
    fill: "#e8e8e8",
    fillOpacity: 0.09,
    transform: "rotate(60 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5.05v18.52a45.2 45.2 0 0 0-15.52 3.62l-9.3-16.1A63.67 63.67 0 0 1 61.5.05z",
    fill: "#d4d4d4",
    fillOpacity: 0.17,
    transform: "rotate(90 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5.05v18.52a45.2 45.2 0 0 0-15.52 3.62l-9.3-16.1A63.67 63.67 0 0 1 61.5.05z",
    fill: "#bebebe",
    fillOpacity: 0.25,
    transform: "rotate(120 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5.05v18.52a45.2 45.2 0 0 0-15.52 3.62l-9.3-16.1A63.67 63.67 0 0 1 61.5.05z",
    fill: "#a6a6a6",
    fillOpacity: 0.35,
    transform: "rotate(150 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5.05v18.52a45.2 45.2 0 0 0-15.52 3.62l-9.3-16.1A63.67 63.67 0 0 1 61.5.05z",
    fill: "#8e8e8e",
    fillOpacity: 0.44,
    transform: "rotate(180 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5.05v18.52a45.2 45.2 0 0 0-15.52 3.62l-9.3-16.1A63.67 63.67 0 0 1 61.5.05z",
    fill: "#737373",
    fillOpacity: 0.55,
    transform: "rotate(210 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5.05v18.52a45.2 45.2 0 0 0-15.52 3.62l-9.3-16.1A63.67 63.67 0 0 1 61.5.05z",
    fill: "#5a5a5a",
    fillOpacity: 0.65,
    transform: "rotate(240 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5.05v18.52a45.2 45.2 0 0 0-15.52 3.62l-9.3-16.1A63.67 63.67 0 0 1 61.5.05z",
    fill: "#414141",
    fillOpacity: 0.75,
    transform: "rotate(270 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5.05v18.52a45.2 45.2 0 0 0-15.52 3.62l-9.3-16.1A63.67 63.67 0 0 1 61.5.05z",
    fill: "#2a2a2a",
    fillOpacity: 0.84,
    transform: "rotate(300 64 64)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5.05v18.52a45.2 45.2 0 0 0-15.52 3.62l-9.3-16.1A63.67 63.67 0 0 1 61.5.05z",
    fill: "#151515",
    fillOpacity: 0.92,
    transform: "rotate(330 64 64)"
  }), /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    values: "0 64 64;30 64 64;60 64 64;90 64 64;120 64 64;150 64 64;180 64 64;210 64 64;240 64 64;270 64 64;300 64 64;330 64 64",
    calcMode: "discrete",
    dur: "840ms",
    repeatCount: "indefinite"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.6936e6fd308d820ee9fc2b2bf3e63b9e.svg";
export { ForwardRef as ReactComponent };